var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStories(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 188,
    viewBox: "0 0 208 188",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.98 58.4951C181.98 40.6184 167.35 26.0004 149.485 26.0004C131.62 26.0004 116.99 40.6299 116.99 58.4951V128.696C116.99 160.867 90.6662 187.191 58.4951 187.191C26.3239 187.191 0 160.867 0 128.696V2.58847H26.0004V128.696C26.0004 146.573 40.6299 161.191 58.4951 161.191C76.3603 161.191 90.9898 146.561 90.9898 128.696V58.4951C90.9898 26.3239 117.314 0 149.485 0C181.656 0 207.98 26.3239 207.98 58.4951V184.591H181.98V58.4951Z",
    fill: "#000001"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStories);
export default __webpack_public_path__ + "static/media/stories.94d44e1fd6555eb77fbb8bb46a5ed124.svg";
export { ForwardRef as ReactComponent };